var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { ELEMENTS_CLASSES, itemClassToType } from "../utils/form-builder.types";
import FormBuilderFormInterfaceDropdown from "../components/form/interface/dropdown/form-builder.form.interface.dropdown";
import FormBuilderFormInterfaceSpacer from "../components/form/interface/spacer/form-builder.form.interface.spacer";
import FormBuilderFormInterfaceHeading from "../components/form/interface/heading/form-builder.form.interface.heading";
import FormBuilderFormInterfaceFullName from "../components/form/interface/full-name/form-builder.form.interface.full-name";
import FormBuilderFormInterfaceHeader from "../components/form/interface/header/form-builder.form.interface.header";
import FormBuilderFormInterfaceTextarea from "../components/form/interface/textarea/form-builder.form.interface.textarea";
import FormBuilderFormInterfaceFileUpload from "../components/form/interface/file-upload/form-builder.form.interface.file-upload";
import FormBuilderFormInterfaceScale from "../components/form/interface/scale/form-builder.form.interface.scale";
import FormBuilderFormInterfaceLine from "../components/form/interface/line/form-builder.form.interface.line";
import FormBuilderFormInterfaceParagraph from "../components/form/interface/paragraph/form-builder.form.interface.paragraph";
import FormBuilderFormInterfaceConsent from "../components/form/interface/consent/form-builder.form.interface.consent";
import FormBuilderFormInterfaceCommunityConsent from "../components/form/interface/community-consent/form-builder.form.interface.community-consent";
import FormBuilderFormInterfaceAcceptance from "../components/form/interface/acceptance/form-builder.form.interface.acceptance";
import FormBuilderFormInterfaceChoice from "../components/form/interface/choice/form-builder.form.interface.choice";
import FormBuilderFormInterfaceImage from "../components/form/interface/image/form-builder.form.interface.image";
import FormBuilderFormInterfaceThumbScale from "../components/form/interface/thumb-scale/form-builder.form.interface.thumb-scale";
import FormBuilderFormInterfaceNumberScale from "../components/form/interface/number-scale/form-builder.form.interface.number-scale";
import FormBuilderFormInterfaceHidden from "../components/form/interface/hidden/form-builder.form.interface.hidden";
import FormBuilderFormInterfaceMatrix from "../components/form/interface/matrix/form-builder.form.interface.matrix";
import FormBuilderFormInterfaceAddress from "../components/form/interface/address/form-builder.form.interface.address";
import FormBuilderFormInterfaceVideo from "../components/form/interface/video/form-builder.form.interface.video";
import Logger from "../../../services/logger/logger";
import React from "react";
import { FormBuilderFormInterfaceInput } from "../components/form/interface/form-builder.form.interface.input";
import FormBuilderFormInterfaceLoyaltySignUp from "../components/form/interface/loyalty-sign-up/form-builder-form-interface-loyalty-sign.up";
export const useRenderElement = ({
  formValuesObj,
  translateFn,
  analyticForm,
  teamId,
  formId,
  apiUrl,
  included,
  setPendingComponents = () => {
  },
  language,
  uploadedImages,
  isPreview
}) => {
  const renderElement = (item) => {
    if (item) {
      switch (itemClassToType(item == null ? void 0 : item.class)) {
        case ELEMENTS_CLASSES.DROPDOWN:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceDropdown, { item, values: formValuesObj, t: translateFn });
        case ELEMENTS_CLASSES.SPACER:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceSpacer, { item });
        case ELEMENTS_CLASSES.HEADING:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceHeading, { item, t: translateFn });
        case ELEMENTS_CLASSES.FULL_NAME:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceFullName,
            {
              item,
              values: formValuesObj,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.SINGLE_LINE_TEXT:
        case ELEMENTS_CLASSES.NUMBER:
        case ELEMENTS_CLASSES.WEBSITE:
        case ELEMENTS_CLASSES.EMAIL:
        case ELEMENTS_CLASSES.PHONE:
        case ELEMENTS_CLASSES.DATE:
        case ELEMENTS_CLASSES.BIRTHDAY:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceInput,
            {
              item,
              values: formValuesObj,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.HEADER:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceHeader, { item, t: translateFn });
        case ELEMENTS_CLASSES.MULTI_LINE_TEXT:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceTextarea,
            {
              item,
              values: formValuesObj,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.FILE_UPLOAD:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceFileUpload,
            {
              item,
              teamId,
              formId,
              apiUrl,
              analyticForm,
              onPending: (isPending, inputName) => setPendingComponents((s) => __spreadProps(__spreadValues({}, s), { [inputName]: isPending })),
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.STAR_RATING:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceScale,
            {
              item,
              values: formValuesObj,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.LINE:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceLine, { item });
        case ELEMENTS_CLASSES.PARAGRAPH:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceParagraph, { item, t: translateFn });
        case ELEMENTS_CLASSES.CONSENT:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceConsent, { item, analyticForm, t: translateFn });
        case ELEMENTS_CLASSES.COMMUNITY_CONSENT:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceCommunityConsent,
            {
              item,
              formId,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.ACCEPTANCE:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceAcceptance, { item, analyticForm, t: translateFn });
        case ELEMENTS_CLASSES.MULTIPLE_CHOICE:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceChoice,
            {
              item,
              formId,
              values: formValuesObj,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.SINGLE_CHOICE:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceChoice,
            {
              item,
              formId,
              values: formValuesObj,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.IMAGE:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceImage,
            {
              item,
              included,
              uploadedImages,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.THUMB_SCALE:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceThumbScale, { item, values: formValuesObj, t: translateFn });
        case ELEMENTS_CLASSES.SMILEY_SCALE:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceScale,
            {
              item,
              values: formValuesObj,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.NUMBER_SCALE:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceNumberScale,
            {
              item,
              values: formValuesObj,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.PRODUCT_ASSOCIATION:
        case ELEMENTS_CLASSES.HIDDEN:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceHidden, { item, values: formValuesObj });
        case ELEMENTS_CLASSES.SINGLE_MATRIX:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceMatrix,
            {
              item,
              values: formValuesObj,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.MULTIPLE_MATRIX:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceMatrix,
            {
              item,
              values: formValuesObj,
              formId,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.ADDRESS:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceAddress,
            {
              item,
              values: formValuesObj,
              formId,
              locale: language,
              onPending: (isPending, inputName) => setPendingComponents((s) => __spreadProps(__spreadValues({}, s), { [inputName]: isPending })),
              isPreview,
              analyticForm,
              t: translateFn
            }
          );
        case ELEMENTS_CLASSES.VIMEO:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceVideo, { item, isPreview });
        case ELEMENTS_CLASSES.YOUTUBE:
          return /* @__PURE__ */ React.createElement(FormBuilderFormInterfaceVideo, { item, isPreview, language });
        case ELEMENTS_CLASSES.LOYALTY_SIGN_UP:
          return /* @__PURE__ */ React.createElement(
            FormBuilderFormInterfaceLoyaltySignUp,
            {
              item,
              analyticForm,
              t: translateFn,
              formId
            }
          );
        default:
          return;
      }
    }
    Logger.error("Invalid item type");
  };
  return { renderElement };
};
